import { render, staticRenderFns } from "./GenericNotifcationApi.vue?vue&type=template&id=44850a91&"
import script from "./GenericNotifcationApi.vue?vue&type=script&lang=ts&"
export * from "./GenericNotifcationApi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports